// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vnWfJ","title":"styles_title__PwuJs","value":"styles_value__1jl4M","editIcon":"styles_editIcon__wTgwZ"};